<div class="d-flex justify-content-center align-items-center w-100 h-100">
  <div id="step-content" class="flex flex-column h-auto p-md-4 p-3">
    <div class="step-content">
      <div class="step-title-wrapper">
        <h5 class="step-title">{{title | translate}}</h5>
      </div>
      <app-form
        [validationEmit]="validationEmit"
        [formConfig]="formConfig"
        [hasButton]="false"
        (onChange)="handleChange($event)"
        (onSubmit)="handleSubmit($event)"
        [changeSensitive]="true">
      </app-form>
    </div>
    <div class="dialog-footer d-flex justify-content-between gap-2 mt-4">
      <button *ngIf="showBackButton" type="button" class="btn btn-outline-main" (click)="handleBack()">
        {{backButtonText | translate}}
      </button>
      <button type="button" class="btn btn-solid-main" (click)="validationEmit = !validationEmit">
        {{isLastStep ? (saveButtonText | translate) : (nextButtonText | translate)}}
      </button>
    </div>
  </div>
</div>
